var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout",class:{'hide-nav': _vm.hideNav, 'show-footer': _vm.showFooter}},[(!_vm.hideNav)?_c('Navbar'):_vm._e(),_c('router-view'),(_vm.showFooter)?_c('Footer'):_vm._e(),_c('MsgModal'),_c('transition',{attrs:{"name":"fade"}},[(_vm.busy)?_c('BusyLoading'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }